import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TenantService } from '../../core/services/tenant.service';
import { AuthenticationService } from '../../core/services/authentication.service';

@Component({
  selector: 'app-tenant-setup',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './tenant-setup.component.html'
})
export class TenantSetupComponent {
  private fb = inject(FormBuilder);
  private tenantService = inject(TenantService);
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  form: FormGroup = this.fb.group({
    villageName: ['', [Validators.required, Validators.minLength(2)]],
    address: ['', [Validators.required]],
    contactPhone: [''],
    contactEmail: ['', [Validators.email]]
  });

  isSubmitting = false;
  errorMessage = '';

  get f() { return this.form.controls; }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    this.tenantService.createTenant(this.form.value).subscribe({
      next: (res) => {
        if (res.success) {
          this.tenantService.invalidateExistsCache();
          this.authService.refreshToken().subscribe({
            next: () => this.router.navigate(['/setup/business-unit']),
            error: () => this.router.navigate(['/setup/business-unit'])
          });
        } else {
          this.errorMessage = res.message || 'Failed to create tenant.';
          this.isSubmitting = false;
        }
      },
      error: () => {
        this.errorMessage = 'An error occurred. Please try again.';
        this.isSubmitting = false;
      }
    });
  }
}
